import type { ReactNode } from "react";

import type { IBoxProps } from "@components/atoms/box";

/**
 * Props for a container component used for wrapping cards.
 *
 * @interface ICardContainerProps
 */
export interface ICardContainerProps {
  /**
   * Additional BoxProps to apply to the container.
   */
  boxProps?: IBoxProps;
  /**
   * The children to be rendered within the container.
   */
  children: ReactNode;
}

/**
 * Default BoxProps for the card container.
 * @type {IBoxProps}
 */
export const defaultBoxProps: IBoxProps = {
  radius: "lg",
  py: "0",
  px: "0",
};
